<template>
    <div class="material">
        <Head></Head>
        <div class="con" style="width:450px">
            <div class="pos">
                <h1 class="adminh1">编辑个人信息</h1>
                <el-form :model="ruleForm" status-icon ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="姓名：" prop="name">
                        <el-input prefix-icon="el-icon-user" style="width: 250px" type="text" v-model="ruleForm.name" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="性别：" prop="sex">
                        <el-radio-group v-model="ruleForm.sex">
                            <el-radio :label="0">男</el-radio>
                            <el-radio :label="1">女</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="地址：" prop="address">
                        <el-select v-model="sheng" @change="shengChage" placeholder="请选择省" style="width:100px">
                            <el-option v-for="(item, index) in shengData" :key="index" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                        <el-select v-model="shi" @change="shiChage" placeholder="请选择市" style="width:100px;margin-top:10px">
                            <el-option v-for="(item, index) in shiData" :key="index" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                        <el-select
                            v-model="xian"
                            @change="xianChage"
                            v-if="inout == '1'"
                            placeholder="请选择县/区"
                            style="width:100px;margin-top:10px"
                        >
                            <el-option v-for="(item, index) in xianData" :key="index" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                        <div style="position: relative;">
                            <el-input
                                v-model="dizhi"
                                placeholder="点击选择自录地址"
                                style=" width: 80%; margin-top: 10px"
                                @keyup.enter.native="mapFun"
                            ></el-input>
                            <a href="javascript:;" @click="mapOpen()" style=" color: #409EFF;display: block;">
                                点击选择自录地址
                            </a>
                        </div>
                    </el-form-item>
                    <el-form-item label="密 码：" prop="password">
                        <el-input
                            prefix-icon="el-icon-menu"
                            style="width: 250px"
                            show-password
                            type="password"
                            v-model="ruleForm.password"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('ruleForm')">修改</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <el-dialog :visible.sync="dialogMap" width="500" class="map">
            <vmap @getLnglat="getPosi" :data="dtdz" :dzData="dizhi"></vmap>
        </el-dialog>
    </div>
</template>

<script>
import api from "@/request/api";
import vmap from "@/components/vmap.vue";
import Head from "@/components/header.vue";

export default {
    name: "register",
    data() {
        return {
            loading: false,
            registerscr: "",
            sendmsgscr: "",
            ruleForm: {
                name: "",
                sex: 0,
                address: "",
                sheng: "",
                shi: "",
                xian: "",
                zhen: "",
                password: ""
            },
            countdown: 60,
            //按钮上的文字
            codeMsg: "获取验证码",
            mobileCode: "",
            //定时器
            timer: null,
            dialogVisible: false,

            inout: 1,
            shengData: [],
            shiData: [],
            xianData: [],
            sheng: "",
            shengName: "",
            shi: "",
            shiName: "",
            xian: "",
            xianName: "",
            zhen: "",
            dizhi: "",
            dialogMap: false,
            dtdz: ""
        };
    },
    components: {
        vmap,
        Head
    },
    mounted() {
        api.myinfo().then((res) => {
            console.log(res);
            this.ruleForm.name = res.data.name;
            this.ruleForm.sex = res.data.sex;
            this.shengName = res.data.sheng;
            this.shiName = res.data.shi;
            this.xianName = res.data.xian;
            this.zhen = res.data.zhen;
            this.dizhi = res.data.address;
            this.getSheng();
        });
    },
    methods: {
        submitForm(formName) {
            this.ruleForm.sheng = this.shengName;
            this.ruleForm.shi = this.shiName;
            this.ruleForm.xian = this.xianName;
            this.ruleForm.zhen = this.zhen;
            this.ruleForm.address = this.dizhi;
            if (this.ruleForm.name == "") {
                this.$message({
                    message: "姓名不能为空",
                    type: "warning"
                });
                return;
            }
            if (this.ruleForm.sheng == "") {
                this.$message({
                    message: "省不能为空",
                    type: "warning"
                });
                return;
            }
            if (this.ruleForm.shi == "") {
                this.$message({
                    message: "市不能为空",
                    type: "warning"
                });
                return;
            }
            if (this.ruleForm.xian == "") {
                this.$message({
                    message: "区县不能为空",
                    type: "warning"
                });
                return;
            }
            if (this.ruleForm.address == "") {
                this.$message({
                    message: "自定义地址不能为空",
                    type: "warning"
                });
                return;
            }
            this.loading = true;
            api.myinfoupdate(this.ruleForm).then((res) => {
                this.loading = false;
                if (res.code == 0) {
                    this.$message({
                        message: "修改成功"
                    });
                } else {
                    this.$message({
                        message: res.msg,
                        type: "warning"
                    });
                }
            });
        },

        getCode() {
            if (!this.timer) {
                this.setTime();
                this.dialogVisible = false;
                api.sendmsg({
                    mobile: this.ruleForm.pass,
                    code: this.mobileCode,
                    type: 1
                }).then((res) => {
                    if (res.code == 0) {
                        this.$message({
                            message: "发送成功"
                        });
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "warning"
                        });
                    }
                });
            }
        },
        //倒计时
        setTime() {
            let _this = this;
            this.timer = setInterval(() => {
                if (_this.countdown > 0 && _this.countdown <= 60) {
                    _this.countdown--;
                    if (_this.countdown !== 0) {
                        _this.codeMsg = "重新发送(" + _this.countdown + ")";
                    } else {
                        clearInterval(_this.timer);
                        _this.codeMsg = "获取验证码";
                        _this.countdown = 60;
                        _this.timer = null;
                    }
                }
            }, 1000);
        },
        // 获取省
        getSheng() {
            api.getSheng(this.inout).then((res) => {
                this.shengData = res.data;
                this.sheng = "";
                for (let i = 0; i < res.data.length; i++) {
                    if (this.shengName == res.data[i].name) {
                        this.sheng = res.data[i].id;
                        this.shengName = res.data[i].name;
                        this.getShi();
                    }
                }
            });
        },
        // 获取市
        getShi() {
            // if (this.sheng != '' && this.inout!='') {
            if (
                this.sheng != "" &&
                this.sheng != undefined &&
                this.sheng != null &&
                this.inout != "" &&
                this.inout != undefined &&
                this.inout != null
            ) {
                api.getShi({ type: this.inout, id: this.sheng }).then((res) => {
                    this.shiData = res.data;
                    this.shi = "";
                    // if (this.data != undefined) {
                    for (let i = 0; i < res.data.length; i++) {
                        if (this.shiName == res.data[i].name) {
                            this.shi = res.data[i].id;
                            this.shiName = res.data[i].name;
                            this.getXian();
                        }
                    }
                    // }
                });
            }
        },
        // 获取县/区
        getXian() {
            if (this.shi != "" && this.shi != undefined && this.shi != null) {
                api.getXian(this.shi).then((res) => {
                    this.xianData = res.data;
                    this.xian = "";
                    // if (this.data != undefined) {
                    for (let i = 0; i < res.data.length; i++) {
                        if (this.xianName == res.data[i].name) {
                            this.xian = res.data[i].id;
                            this.xianName = res.data[i].name;
                        }
                    }
                    // }
                });
            }
        },
        shengChage(e) {
            for (const key in this.shengData) {
                if (this.shengData[key].id == e) {
                    this.shengName = this.shengData[key].name;
                    this.dizhi = this.shengName;
                }
            }
            this.shi = "";
            this.xian = "";
            this.getShi();
        },
        shiChage(e) {
            // this.shiData.forEach((item) => {
            //     if (item.id == e) {
            //         this.shiName = item.name;
            //         this.dizhi = this.shengName + this.shiName;
            //     }
            // });
            for (const key in this.shiData) {
                if (this.shiData[key].id == e) {
                    this.shiName = this.shiData[key].name;
                    this.dizhi = this.shengName + this.shiName;
                }
            }
            this.xian = "";
            this.getXian();

            this.getCoordinate();
        },
        xianChage(e) {
            for (const key in this.xianData) {
                if (this.xianData[key].id == e) {
                    this.xianName = this.xianData[key].name;
                    this.dizhi = this.shengName + this.shiName + this.xianName;
                }
            }
            this.getCoordinate();
        },
        getCoordinate() {
            if (this.sheng != "" && this.shi != "") {
                api.getCoordinate(
                    this.$qs.stringify({
                        type: this.inout,
                        sheng: this.shengName,
                        shi: this.shiName,
                        xian: this.xianName
                    })
                ).then((res) => {
                    this.dtdz = res.data;
                });
            }
        },
        //地图定位
        mapOpen() {
            this.dialogMap = true;
        },
        getPosi(lng, lat, address) {
            this.dtdz = lng + ", " + lat;
            this.dizhi = address;
            this.dialogMap = false;
        }
    }
};
</script>
<style lang="less">
.material {
    .con {
        width: 500px;
        margin: 0 auto;
        h1 {
            font-size: 24px;
            text-align: center;
            margin: 20px 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/material.vue